import { Color } from '@kite-js/theme-types';

const blue: Color = {
    // Remove this block when do SKYWL-471
    // ------------------------------
    50: '#f4f8fe',
    200: '#75a8f9',
    400: '#396fc6',
    // ------------------------------

    100: '#E8F2FF',
    300: '#007AFF',
    500: '#004499',
};

export default blue;
